(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      if(Debutify.settings.dbtfy_sticky_header == false) return;

      this.defaultColorScheme = "dbtfy-color-"+this.dataset.colorScheme;
      this.defaultCustomColorScheme = "color-"+this.dataset.customColorScheme;
      this.transparentColorScheme = "dbtfy-color-"+this.dataset.transparentHeaderColorScheme;
      this.transparentCustomColorScheme = "color-"+this.dataset.customTransparentHeaderColorScheme;
      
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {
        top: 0,
        bottom: this.header.offsetHeight
      };

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      if((Debutify.widgets.header.header_transparent && document.body.classList.contains('template-index')) || (Debutify.widgets.header.collection_header_transparent && document.body.classList.contains('template-collection'))){
        if (window.pageYOffset <= 0) {
          this.classList.add('dbtfy-header--transparent');
          this.classList.add(this.transparentColorScheme);
          this.classList.add(this.transparentCustomColorScheme);
        } else {
          this.classList.remove('dbtfy-header--transparent');
          if (this.transparentColorScheme) this.classList.remove(this.transparentColorScheme);
          if (this.transparentCustomColorScheme) this.classList.remove(this.transparentCustomColorScheme);

          this.classList.add(this.defaultColorScheme, this.defaultCustomColorScheme);
        }
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();

      requestAnimationFrame(() => {
        this.onScroll();
      });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.headerRounded = this.dataset.headerRounded;
        this.headerWidth = this.dataset.headerWidth;
        
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
        
        if((Debutify.widgets.header.header_transparent && document.body.classList.contains('template-index')) || (Debutify.widgets.header.collection_header_transparent && document.body.classList.contains('template-collection'))){
          this.classList.add(this.defaultColorScheme,this.defaultCustomColorScheme);
          if(this.classList.contains("dbtfy-header--transparent")){
            this.classList.remove('dbtfy-header--transparent');
          }
         if(this.transparentColorScheme && this.transparentColorScheme !== this.defaultColorScheme){
            this.classList.remove(this.transparentColorScheme);
          }
          if (this.transparentCustomColorScheme && this.transparentCustomColorScheme !== this.defaultCustomColorScheme) {
            this.classList.remove(this.transparentCustomColorScheme);
          }
        }
        if (this.headerRounded == 'true') {
          this.classList.add('header-rounded');
          this.classList.add(`${this.headerWidth}`);
          this.classList.remove('header-rounded-ease-out');
        }
        
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {

        if((Debutify.widgets.header.header_transparent && document.body.classList.contains('template-index')) || (Debutify.widgets.header.collection_header_transparent && document.body.classList.contains('template-collection'))){
          this.classList.add(this.transparentColorScheme,this.transparentCustomColorScheme,'dbtfy-header--transparent');
          if(this.defaultColorScheme && this.defaultColorScheme !== this.transparentColorScheme){
            this.classList.remove(this.defaultColorScheme);
          }
          if (this.defaultCustomColorScheme && this.defaultCustomColorScheme !== this.transparentCustomColorScheme) {
            this.classList.remove(this.defaultCustomColorScheme);
          }
        }

        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));

        if (this.headerRounded == 'true') {
          this.classList.remove('header-rounded');
          this.classList.remove(`${this.headerWidth}`);
          this.classList.add('header-rounded-ease-out');
        }
      }
      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skinder-homepage"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('skinder-product-carousel')) {
    customElements.define(
      'skinder-product-carousel',
      class extends HTMLElement {
        connectedCallback() {
          if (this._controller) return;
          if (!this.querySelector('.spc-track')) {
            this._initFrame = requestAnimationFrame(() => {
              if (this.isConnected) this.connectedCallback();
            });
            return;
          }
          this._controller = new AbortController();
          const signal = this._controller.signal;
          this.track = this.querySelector('.spc-track');
          this.prev = this.querySelector('[data-spc-prev]');
          this.next = this.querySelector('[data-spc-next]');
          this.dots = this.querySelector('.spc-dots');
          this.targets = [];
          if (!this.track) return;
          this.prev.addEventListener('click', () => this.move(-1), { signal });
          this.next.addEventListener('click', () => this.move(1), { signal });
          this.track.addEventListener(
            'scroll',
            () => {
              cancelAnimationFrame(this._frame);
              this._frame = requestAnimationFrame(() => this.update());
            },
            { passive: true, signal }
          );
          this.addEventListener(
            'shopify:block:select',
            (e) => {
              const card = e.target.closest('.spc-card');
              if (card && this.contains(card)) {
                const left =
                  card.getBoundingClientRect().left - this.track.getBoundingClientRect().left + this.track.scrollLeft;
                this.scrollToTarget(left);
              }
            },
            { signal }
          );
          this.track.addEventListener(
            'keydown',
            (e) => {
              if (e.target !== this.track) return;
              if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
                e.preventDefault();
                this.move(e.key === 'ArrowRight' ? 1 : -1);
              }
            },
            { signal }
          );
          this._observer = new ResizeObserver(() => this.layout());
          this._observer.observe(this.track);
          this.layout();
        }
        disconnectedCallback() {
          this._controller?.abort();
          this._controller = null;
          this._observer?.disconnect();
          cancelAnimationFrame(this._frame);
          cancelAnimationFrame(this._initFrame);
        }
        layout() {
          const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
          const cards = [...this.track.querySelectorAll('.spc-card')];
          const trackLeft = this.track.getBoundingClientRect().left;
          this.targets = [
            ...new Set(
              cards.map((c) =>
                Math.round(Math.min(max, c.getBoundingClientRect().left - trackLeft + this.track.scrollLeft))
              )
            ),
          ];
          if (!this.targets.length) this.targets = [0];
          this.prev.hidden = this.next.hidden = max < 2;
          const media = cards[0]?.querySelector('.spc-media');
          if (media) {
            this.prev.style.top = this.next.style.top = Math.max(12, media.getBoundingClientRect().height - 44) + 'px';
          }
          this.dots.replaceChildren();
          this.targets.forEach((target, index) => {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'spc-dot';
            dot.setAttribute('aria-label', 'Show product group ' + (index + 1));
            dot.addEventListener('click', () => this.scrollToTarget(target));
            this.dots.append(dot);
          });
          this.dots.hidden = this.dataset.dots !== 'true' || this.targets.length < 2;
          this.update();
        }
        update() {
          const pos = this.track.scrollLeft,
            max = this.track.scrollWidth - this.track.clientWidth;
          this.prev.disabled = pos < 2;
          this.next.disabled = pos >= max - 2;
          let index = 0;
          this.targets.forEach((x, i) => {
            if (Math.abs(x - pos) < Math.abs(this.targets[index] - pos)) index = i;
          });
          [...this.dots.children].forEach((dot, i) => dot.setAttribute('aria-current', i === index ? 'true' : 'false'));
        }
        scrollToTarget(left) {
          this.track.scrollTo({
            left,
            behavior: matchMedia('(prefers-reduced-motion:reduce)').matches ? 'auto' : 'smooth',
          });
        }
        move(direction) {
          const pos = this.track.scrollLeft;
          const target =
            direction > 0
              ? this.targets.find((x) => x > pos + 2)
              : [...this.targets].reverse().find((x) => x < pos - 2);
          if (target !== undefined) this.scrollToTarget(target);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
